import { Editor } from 'slate';
import { ReactEditor } from 'slate-react';
import isMarkActive, { MarkName } from '@atlas/tool/box/slate/isMarkActive';
import toggleLink from '@atlas/tool/box/slate/toggleLink';
import changeEditorSelection from '@atlas/tool/box/slate/changeEditorSelection';

export default function toggleMark(editor: Editor, mark: MarkName) {
    if (!editor.selection) {
        const point = Editor.end(editor, []);
        changeEditorSelection(editor, { anchor: point, focus: point });
        queueMicrotask(() => ReactEditor.focus(editor));
    }

    if (mark === 'link') return toggleLink(editor);
    const isActive = isMarkActive(editor, mark);
    if (isActive) Editor.removeMark(editor, mark);
    else Editor.addMark(editor, mark, true);
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('toggleMark', () => {
        it.todo('🤷🏼');
    });
}

// #endregion
